import React from 'react'

const NotFound = () => {
  return (
    <div>
      <h2>Error Check Link again</h2>
    </div>
  )
}

export default NotFound
